export enum ETypeEtapeBonTravail {
    EntretienPreventif = 1,
    EntretienCorrectif = 2,
    Autre = 3,
    ListeVerificaton = 4
}